import React from 'react';
import mapNodes from 'helpers/mapNodes';
import PropTypes from 'prop-types';
import BlogsPage from 'components/BlogsPage';

const propTypes = {
  data: PropTypes.shape({
    allContentfulPost: PropTypes.object,
    allContentfulPostCategory: PropTypes.object,
  }).isRequired,

  pathContext: PropTypes.shape({ selectedCategoryId: PropTypes.string })
    .isRequired,
};

function BlogsPageContainer({ data, pathContext }) {
  return (
    <BlogsPage
      posts={mapNodes(data.allContentfulPost)}
      postCategories={mapNodes(data.allContentfulPostCategory)}
      selectedCategoryId={pathContext.selectedCategoryId}
      seoTitle={pathContext.seoTitle}
      seoKeywords={pathContext.seoKeywords}
      seoDescription={pathContext.seoDescription}
    />
  );
}

BlogsPageContainer.propTypes = propTypes;

export default BlogsPageContainer;

export const query = graphql`
  query BlogsPageQuery {
    allContentfulPost(
      filter: { node_locale: { eq: "en-US" } }
      sort: { fields: [createdAt], order: DESC }
    ) {
      edges {
        node {
          id
          node_locale
          heading
          slug
          categories {
            id
            title
            slug
          }
          content {
            id
            content
          }
          headerBackgroundImage {
            responsiveResolution(width: 800) {
              width
              height
              src
              srcSet
            }
          }
        }
      }
    }

    allContentfulPostCategory(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
          id
          title
          slug
          seoDescription {
            seoDescription
          }
          seoKeywords
          seoTitle
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/tapd-in.js